import { Injectable } from '@angular/core';

import { environment } from '../../../environments/environment';
import { CreateAcademicPeriods } from '../../_models/system-setting/academic-year-manage/create-academic-periods.interface';
import { UpdateAcademicPeriods } from '../../_models/system-setting/academic-year-manage/update-academic-periods.interface';
import { AcademicPeriods } from '../../_models';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class AcademicPeriodsService {
  private url: string;

  constructor(public http: HttpClient) {
    this.url = `${environment.apiUrl}AcademicYear`;
  }

  getAllBySemesterId(id: number) {
    return this.http.get(`${this.url}/GetAllAcademicPeriod/${id}`);
  }

  getById(id: number) {
    return this.http.get(`${this.url}/GetAcademicPeriod/${id}`);
  }

  insert(items: CreateAcademicPeriods) {
    return this.http.post(`${this.url}/CreateAcademicPeriod`, items);
  }

  update(items: UpdateAcademicPeriods) {
    return this.http.put(`${this.url}/UpdateAcademicPeriod`, items);
  }

  delete(items: AcademicPeriods) {
    return this.http.delete(`${this.url}/DeletAcademicPeriod/${items.academicPeriodId}`);
  }
}
